import React from 'react';
import ToyotaMessagesTrendChart from './ToyotaMessagesTrendChart';
import RaymondMessagesTrendChart from './RaymondMessagesTrendChart';

const MessagesTrendChart = ({ chartFilters, selectedManufacturer = 'toyota' }) => {
  const isRaymond = selectedManufacturer === 'raymond-us' || selectedManufacturer === 'raymond-eu';
  
  if (isRaymond) {
    return <RaymondMessagesTrendChart chartFilters={chartFilters} selectedManufacturer={selectedManufacturer} />;
  }
  
  return <ToyotaMessagesTrendChart chartFilters={chartFilters} selectedManufacturer={selectedManufacturer} />;
};

export default MessagesTrendChart;
